import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon, HiddenField, ProfileIcon, SmallText } from '@guryou/html-components';
import { Box } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  cube: {
    width: 145,
    minHeight: 140,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: '0.3s',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid #ccc',
    backgroundColor: '#f9f9f9',
    padding: theme.spacing(1),
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#efefef',
      borderColor: '#888',
    },
  },
  selected: {
    borderColor: '#3aa61b',
    backgroundColor: '#f5fff2',
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginBottom: theme.spacing(1),
    backgroundColor: '#bdbdbd',
    color: '#fff',
    fontSize: '1.2rem',
    transition: '0.3s',
  },
  avatarSelected: {
    backgroundColor: '#3aa61b',
    // color: '#212121',
  },
  nameText: {
    fontSize: '0.80rem',
    fontWeight: 600,
    color: '#333',
    wordWrap: 'break-word',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

// const users = [
//   { id: 1, name: 'Petar' },
//   { id: 2, name: 'Ariana' },
//   { id: 3, name: 'Stefan' },
// ];

const SelectableCubeGroup = ({ resources, values, error, setError, multiple = true }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [selectedIds, setSelectedIds] = useState(values || []);

  const toggleSelection = id => {
    if (!id) {
      return;
    }
    if (multiple) {
      setSelectedIds(prev => (prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]));
    } else {
      setSelectedIds([id]);
    }
    setError(false);
  };

  const res = resources?.slice(0, 3) || [];

  return (
    <>
      <Grid container justifyContent={res.length === 1 ? 'start' : res.length === 2 ? 'space-evenly' : 'space-between'}>
        {res.map(user => {
          const isSelected = selectedIds.includes(user.id);
          return (
            <Grid item key={user.id}>
              <Box
                elevation={isSelected ? 6 : 2}
                className={`${classes.cube} ${isSelected ? classes.selected : ''}`}
                onClick={() => toggleSelection(user.id)}
              >
                <Avatar className={`${classes.avatar} ${isSelected ? classes.avatarSelected : ''}`}>
                  {isSelected ? <CheckIcon /> : <ProfileIcon />}
                </Avatar>
                <Typography className={classes.nameText}>{user.name}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
      {multiple ? <HiddenField name="resources" value={selectedIds} /> : <HiddenField name="resourceId" value={selectedIds[0]} />}
      {error && (
        <SmallText color="red" marginTop={2}>
          {t('ONBOARD.pleaseSelectStaff')}
        </SmallText>
      )}
    </>
  );
};

export default SelectableCubeGroup;
